import Chip from '@mui/material/Chip';

interface StatusChipProps {
  active: boolean;
  activeLabel?: string;
  inactiveLabel?: string;
}

/**
 * Reusable status badge — renders a colored chip for active/inactive states.
 */
export function StatusChip({
  active,
  activeLabel = 'Active',
  inactiveLabel = 'Disabled',
}: StatusChipProps) {
  return (
    <Chip
      label={active ? activeLabel : inactiveLabel}
      size="small"
      color={active ? 'success' : 'error'}
      variant="outlined"
    />
  );
}
